import * as bus from "@sinch/bus";

const store: Map<string, { body: object; expires: number }> = new Map();

export const busReplayBroker = () => {
  const unsubPublish = bus.listen(
    (message: bus.Message<string, unknown, unknown, bus.ReplayHeaders>) => {
      if (!bus.isData(message)) {
        return;
      }
      if (typeof message.meta === "undefined") {
        store.delete(message.type);
        return;
      }
      const { isReplayable, expiresInMs } = message.meta;
      const expires =
        typeof expiresInMs === "number" ? Date.now() + expiresInMs : Infinity;

      if (isReplayable) {
        store.set(message.type, {
          body: message.payload ?? {},
          expires,
        });
      } else {
        store.delete(message.type);
      }
    }
  );

  const unsubReplayReq = bus.listen((message: bus.RequestReplayMessage) => {
    if (!bus.isData(message)) {
      return;
    }

    const replayMessage = store.get(message.payload.type);
    if (!replayMessage) {
      bus.sendLocal(bus.createResponseReplayMessage(message.type, undefined));
      return;
    }

    if (Date.now() < replayMessage.expires) {
      bus.sendLocal(
        bus.createResponseReplayMessage(
          message.payload.type,
          replayMessage.body
        )
      );
    }
  }, bus.isRequestReplayMessage);
  return () => {
    unsubPublish();
    unsubReplayReq();
  };
};
